export const sortAlphabetically = (value1, value2, order = 'asc') => {
  if (order === 'asc') {
    return value1.localeCompare(value2, 'en', { sensitivity: 'base' });
  }
  return value2.localeCompare(value1, 'en', { sensitivity: 'base' });
};
